var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 5.07201C18.4522 6.33868 19.457 7.98472 19.9429 9.81079C20.4288 11.6369 20.3748 13.5646 19.7874 15.3606C19.2001 17.1566 18.1047 18.7438 16.6338 19.93C15.1629 21.1162 13.3797 21.8505 11.5 22.044V25C11.5 25.2652 11.3946 25.5196 11.2071 25.7071C11.0196 25.8947 10.7652 26 10.5 26C10.2348 26 9.98043 25.8947 9.79289 25.7071C9.60536 25.5196 9.5 25.2652 9.5 25V22.044C7.62033 21.8505 5.83707 21.1162 4.36618 19.93C2.89529 18.7438 1.79986 17.1566 1.21255 15.3606C0.625239 13.5646 0.571241 11.6369 1.05709 9.81079C1.54295 7.98472 2.54781 6.33868 3.95 5.07201L8.824 0.672008C9.2835 0.256849 9.88073 0.0270081 10.5 0.0270081C11.1193 0.0270081 11.7165 0.256849 12.176 0.672008L17.05 5.07201ZM11.5 11.002C11.5 10.7368 11.3946 10.4824 11.2071 10.2949C11.0196 10.1074 10.7652 10.002 10.5 10.002C10.2348 10.002 9.98043 10.1074 9.79289 10.2949C9.60536 10.4824 9.5 10.7368 9.5 11.002V20.03C10.164 20.1137 10.836 20.1137 11.5 20.03V11.002Z",
    fill: "#3C072E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeaf);
export default __webpack_public_path__ + "static/media/ic_leaf.83f5f51431f3e068448695f767e0e0ed.svg";
export { ForwardRef as ReactComponent };